<template>
    <v-menu offset-y>
        <template v-slot:activator="{ on }">
            <v-btn class="hidden-sm-and-down orange--text text--lighten-2" text dark v-on="on">
                {{ $t('changeStatus') }}
            </v-btn>
            <v-btn class="mx-2 hidden-md-and-up" color="primary" dark icon v-on="on">
                <v-icon>edit</v-icon>
            </v-btn>
        </template>
        <v-list>
            <v-list-item
                    v-for="(status) in statuses"
                    :key="status.id"
                    @click="statusSelected(status.id)"
            >
                <v-list-item-title>{{ status.name }}</v-list-item-title>
            </v-list-item>
        </v-list>
    </v-menu>
</template>

<script>
    export default {
        name: "SalesStatusMenu",
        props: ['statuses'],
        methods: {
            statusSelected (id) {

            }
        }
    }
</script>

<style scoped>

</style>
